//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['property', 'building'],
    data: function data() {
        return {
            isDelete: window.validator.can(['delete-unit', 'delete-all']),
            showBuilding: { default: true },
            buildingNumber: { default: '' },
            loading: true,
            filterKey: '',
            roleName: '',
            buildings: [],
            unitStats: [],
            statsLoading: true,
            unitCurrentStatus: 'all',
            unitStatusues: {
                all: ['Rented', 'Model', 'Down', 'Vacant - Not Leased', 'Vacant - Leased', 'NTV - Available', 'NTV - Leased', 'Shop', 'Rehab', 'Pending Approval'],
                leased: ['Rented', 'Vacant - Leased', 'NTV - Leased'],
                available: ['Vacant - Not Leased', 'Vacant - Leased', 'NTV - Available']
            }
        };
    },

    watch: {
        building: function building(newVal, oldVal) {
            if (newVal) {
                this.loading = true;
                this.statsLoading = true;
                this.buildings = [];
                this.unitStats = [];
                this.building = newVal;
                this.refreshData();
            }
        }
    },
    methods: {
        refilter: function refilter() {
            var btemp = this.buildings;
            this.buildings = btemp;
        },
        update: function update(item) {
            Event.$emit('edit-unit', item);
        },
        unitsToDisplay: function unitsToDisplay(building) {

            var self = this;

            // 'Rented','Model','Down','Vacant - Not Leased','Vacant - Leased','NTV - Available','NTV - Leased'

            if (!building.units || !building.units.length) {

                return [];
            }

            var filtered = building.units.filter(function (u) {
                if (self.filterKey) {
                    return self.unitStatusues[self.unitCurrentStatus].includes(u.status) && u.name.toLowerCase().indexOf(self.filterKey) > -1;
                } else {
                    return self.unitStatusues[self.unitCurrentStatus].includes(u.status);
                }
            });

            return filtered;
        },
        changeUnitStatus: function changeUnitStatus(stat) {

            this.unitCurrentStatus = this.unitCurrentStatus == stat ? 'all' : stat;
        },
        remove: function remove(item) {
            if (window.user.role !== 'super-admin') {
                this.$snotify.info('Please contact Help Desk to remove duplicate Units');
            } else {
                Event.$emit('confirm-delete', item, '/prototype/units/delete', 'unit-deleted');
            }
        },
        addUnit: function addUnit() {
            if (window.user.role !== 'super-admin') {
                this.$snotify.info('Please contact Help Desk to create Units');
            } else {
                var $el = this;
                //Event.$emit('close-full-modal');
                //Event.$emit('add-unit');
                if ($el.building) {
                    //console.log($el.building);
                    Event.$emit('add-unit', {
                        action: 'view-building',
                        item: $el.building
                    });
                } else {
                    Event.$emit('close-full-modal');
                    Event.$emit('add-unit');
                }
            }
        },
        viewUnit: function viewUnit(unitID) {
            Event.$emit('view-unit', unitID);
        },
        refreshData: function refreshData() {
            var $el = this;

            if ($el.property) {
                this.loading = true;
                this.statsLoading = true;
                axios.get('/prototype/properties/buildings').then(function (response) {
                    if (response.data) {
                        $el.buildings = response.data;
                        $el.loading = false;
                    }
                });

                axios.get('/prototype/properties/stats').then(function (response) {
                    if (response.data) {
                        $el.unitStats = response.data;
                        $el.statsLoading = false;
                    }
                });
            }
            if ($el.building) {
                this.loading = true;
                this.statsLoading = true;
                axios.get('/prototype/units/showBuilding/' + $el.building).then(function (response) {
                    if (response.data) {
                        $el.buildings = [response.data];
                        $el.loading = false;
                    }
                });

                axios.get('/prototype/buildings/' + $el.building + "/stats").then(function (response) {
                    if (response.data) {
                        $el.unitStats = response.data;
                        $el.statsLoading = false;
                    }
                });
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        var $el = this;

        this.refreshData();

        Event.$on('show-property-tab-units', function () {
            return _this.refreshData();
        });

        Event.$on('unit-added', function () {
            $el.refreshData();
        });
        Event.$on('unit-deleted', function () {
            $el.refreshData();
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/unit/UnitList.vue
// module id = AA8k
// module chunks = 0 1